import {
  FETCH_LAYOUTS_FAILURE,
  FETCH_LAYOUTS_REQUEST,
  FETCH_LAYOUTS_SUCCESS,
  RESET_LAYOUTS_FILTER,
  SET_ALL_FILTERS,
  SET_LAYOUTS_FILTERS,
  SET_LAYOUTS_ITEMS,
} from './actionTypes'
import { LayoutsActionsType, LayoutsStateType } from './types'

const initialState: LayoutsStateType = {
  pending: false,
  layouts: null,
  error: null,
  filters: {
    rooms: {
      studio: null,
      1: null,
      2: null,
      more: null,
    },
    'price-from': null,
    'price-to': null,
    area_from: null,
    area_to: null,
    date: null,
    renovation: null,
    stage_from: null,
    stage_to: null,
    sorting: '',
    notFirstStage: null,
    notLastStage: null,
  },
  items: [],
}

// eslint-disable-next-line @typescript-eslint/default-param-last
const layoutsReducer = (state = initialState, action: LayoutsActionsType) => {
  switch (action.type) {
    case FETCH_LAYOUTS_REQUEST:
      return {
        ...state,
        pending: true,
      }
    case FETCH_LAYOUTS_SUCCESS:
      return {
        ...state,
        pending: false,
        layouts: action.payload,
        error: null,
      }
    case FETCH_LAYOUTS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      }
    case SET_LAYOUTS_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.name]: action.payload.value,
        },
      }
    case SET_LAYOUTS_ITEMS:
      return {
        ...state,
        items: [...action.payload],
      }
    case RESET_LAYOUTS_FILTER:
      return {
        ...state,
        filters: {
          rooms: {
            studio: null,
            1: null,
            2: null,
            more: null,
          },
          'price-from': null,
          'price-to': null,
          area_from: null,
          area_to: null,
          date: null,
          renovation: null,
          stage_from: null,
          stage_to: null,
          sorting: '',
          notFirstStage: null,
          notLastStage: null,
        },
      }
    case SET_ALL_FILTERS:
      return {
        ...state,
        filters: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}

export default layoutsReducer
